import { TRPCClientError, type TRPCLink } from "@trpc/client";
import { observable } from "@trpc/server/observable";
import type { AppRouter } from "@bookdental/api";

export const MENSAGEM_SO_LEITURA = "Esta ficha está aberta só para leitura. Abra na clínica para alterar.";

/** Recusa no cliente toda mutação fora da lista (prefixos de procedure) — a ficha de outra clínica
 *  aberta pelo acesso pessoal só agenda e pede prótese, mesmo onde a tela esquecer de esconder. */
export const soLeituraLink =
  (liberadas: string[]): TRPCLink<AppRouter> =>
  () =>
  ({ next, op }) =>
    observable((observer) => {
      if (op.type === "mutation" && !liberadas.some((p) => op.path === p || op.path.startsWith(`${p}.`))) {
        observer.error(TRPCClientError.from(new Error(MENSAGEM_SO_LEITURA)));
        return;
      }
      return next(op).subscribe(observer);
    });
